import { Resource as s } from "@coveo/platform-client";
const t = class t extends s {
  /**
   * List MCP Pipelines.
   *
   * @param {MCPPipelinesListOptions} options The list options.
   */
  list(i) {
    return this.api.get(
      this.buildPath(t.baseUrl, { organizationId: this.api.organizationId, ...i })
    );
  }
};
t.baseUrl = "/rest/search/v2/admin/mcp/pipelines";
let a = t;
export {
  a as MCPPipelinesResource
};
//# sourceMappingURL=MCPPipelinesResource.js.map
